import { render, staticRenderFns } from "./rateHotelEvents.vue?vue&type=template&id=561ed29e"
import script from "./rateHotelEvents.vue?vue&type=script&lang=js"
export * from "./rateHotelEvents.vue?vue&type=script&lang=js"
import style0 from "./rateHotelEvents.vue?vue&type=style&index=0&id=561ed29e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VChip,VIcon,VTooltip})
